import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';

export interface RadioInputOptions {
  label: string;
  value: string | number | boolean;
}

@Component({
  selector: 'ui-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioInputComponent implements OnInit {
  @Input() public options: Array<RadioInputOptions> = [];
  @Input() public control: FormControl<string | number | boolean | null> =
    new FormControl<string | number | boolean | null>(null);
  @Input() public isDisabled = false;
  @Input() public orientation: 'horizontal' | 'vertical' = 'vertical';

  public ngOnInit(): void {
    if (this.isDisabled) {
      this.control.disable();
    }
  }
}
